export const GET_SALES_INVOICES = "GET_SALES_INVOICES";
export const GET_SALES_INVOICE = "GET_SALES_INVOICE";
export const ADD_SALES_INVOICE = "ADD_SALES_INVOICE";
export const DELETE_SALES_INVOICE = "DELETE_SALES_INVOICE";
export const UPDATE_SALES_INVOICE = "UPDATE_SALES_INVOICE";
